import { render, staticRenderFns } from "./LayoutPreviewModal.vue?vue&type=template&id=1dd5a43a"
import script from "./LayoutPreviewModal.vue?vue&type=script&lang=js"
export * from "./LayoutPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd5a43a')) {
      api.createRecord('1dd5a43a', component.options)
    } else {
      api.reload('1dd5a43a', component.options)
    }
    module.hot.accept("./LayoutPreviewModal.vue?vue&type=template&id=1dd5a43a", function () {
      api.rerender('1dd5a43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/layout-preview/LayoutPreviewModal.vue"
export default component.exports